import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Trash2 } from "lucide-react";
import { api, errorMessage } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useT } from "../i18n";

export const DeleteAccount = () => {
  const { logout } = useAuth();
  const { t } = useT();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const confirm = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.delete("/account", { data: { password } });
      localStorage.removeItem("rox_token");
      await logout();
      navigate("/", { replace: true });
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  if (!open) {
    return (
      <button data-testid="delete-account-button" onClick={() => setOpen(true)} className="mt-10 flex w-full items-center justify-center gap-2 py-2 text-xs font-semibold uppercase tracking-[0.16em] text-rox-muted transition-colors hover:text-rox-orange">
        <Trash2 size={14} /> {t("delete_account")}
      </button>
    );
  }
  return (
    <form onSubmit={confirm} className="panel mt-10 space-y-3 border-rox-orange/40 p-4" data-testid="delete-account-panel">
      <p className="h-display text-2xl">{t("delete_account")}</p>
      <p className="text-sm text-rox-off/80">{t("delete_account_warning")}</p>
      <input data-testid="delete-account-password" className="field" type="password" placeholder={t("password")} value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" />
      {error && <p data-testid="delete-account-error" className="text-sm text-rox-orange">{error}</p>}
      <div className="flex gap-2">
        <button type="button" data-testid="delete-account-cancel" onClick={() => { setOpen(false); setPassword(""); setError(""); }} className="btn-ghost flex-1 py-3 text-sm">{t("cancel")}</button>
        <button data-testid="delete-account-confirm" disabled={busy || !password} className="btn-primary flex-1 py-3 text-sm">{t("delete_confirm")}</button>
      </div>
    </form>
  );
};
